import translations from "../assets/locals/translations";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import {
  addBankToDb,
  clearaddBank,
} from "../redux/slices/Master/addBankSlice";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import AlertDeleteModal from "../components/AlertDelete/AlertDeleteModal";
import PersistentDataGrid from "../components/table/PersistentDataGrid";
import { GridToolbar } from "@mui/x-data-grid";
import Checkbox from "@mui/material/Checkbox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons/faEllipsisV";
import { Tooltip } from "@mui/material";
import { setShowMessage } from "../redux/slices/notificationSlice";
import { editBankToDb } from "../redux/slices/Master/editBankSlice";

const AddBank = () => {
  const currentLanguage = useSelector((state) => state.language.language);
  const bankState = useSelector((state) => state.addBankState.addBank);
  console.log(bankState, "bankState!!!!!!!!!!!!!!!!!!!!")
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const redirectModal = () => {
    navigate("/administration/configuration");
  };
  const [bank, setBank] = useState({
    bankname: "",
  });

  const [deleteMessage, setDeleteMessage] = useState(null);
  const [show, setShow] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [banklist, setBankList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const handleHeaderCheckboxClick = () => {
    setSelectAll(!selectAll);
  };


  const [holidayColumnShowHideModel, setHolidayColumnShowHideModel] = useState({});

  const handleHolidayColumnShowHideChange = (holiday_newShowHideModel) => {
    setHolidayColumnShowHideModel(holiday_newShowHideModel);
    localStorage.setItem('holiday_columnShowHide', JSON.stringify(holiday_newShowHideModel));
  };

  useEffect(() => {
    const holiday_savedShowHideModel = JSON.parse(localStorage.getItem('holiday_columnShowHide'));
    if (holiday_savedShowHideModel) {
      setHolidayColumnShowHideModel(holiday_savedShowHideModel);
    }
  }, []);

  const handleChildCheckboxClick = (itemId) => {
    const updatedRowsData = rowData.map((row) => {
      if (row.id == itemId) {
        return {
          ...row,
          checkbox: !row.checkbox,
        };
      }
      return row;
    });
    setRowData(updatedRowsData);
  };
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleShow = () => {
    setShow(1);
  };
  const handleClose = () => {
    setShow(0);
    setBank({
      bankname: "",
    });
  };

  function changeHandler(e) {
    const name = e.target.name;
    const value = e.target.value;

    setBank((bank) => ({ ...bank, [name]: value }));
  }

  const savedata = () => {
    console.log(bank, "fffffffffffffffffffff")
    if (show === 2) {
      dispatch(editBankToDb(bank));
      dispatch(setShowMessage(translations[currentLanguage].bankedited || "Bank Edited"));
      setShow(0);
      setBank({
        bank: "",
      });
      fetchBankList()
    } else {
      dispatch(addBankToDb(bank));
      dispatch(setShowMessage(translations[currentLanguage].bankadded || "Bank Added"));
      clearInpHook();
      setShow(0);
      fetchBankList()
    }
  };
  useEffect(() => {
    if (bankState?.isSuccess) {
      if (bankState.message.result === "success") {
        dispatch(clearaddBank());
      }
    }
  }, [bankState]);

  useEffect(() => {
    fetchBankList()
  }, [])
  const fetchBankList = async () => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/get-bank-list`;
      const token = localStorage.getItem("rbacToken");
      const config = {
        headers: {
          token: token,
        },
      };

      const response = await Axios.get(url, config);

      if (response.data?.isSuccess) {
        console.log(response.data.result, "response.data.result");
        setBankList(response.data.result);
      } else {
        console.error("API request was not successful");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const deleteActionCall = (data) => {
    console.log(data, "ddddddfghjkl;")
    setType("bank_delete");
    setId(data.id);
    setDeleteMessage(
      `${translations[currentLanguage].deletebankmsg || "Are You Sure You Want To Delete The bank"} '${data.bankname}'?`
    );
    setDisplayConfirmationModal(true);
  };

  const submitDelete = async (e, id) => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/delete-bank/${id}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };
      const response = await Axios.get(url, config);

      if (response.data && response.data.isSuccess) {
        dispatch(setShowMessage(translations[currentLanguage].bankdeleted || "Bank Deleted"));
        setDisplayConfirmationModal(false);
      } else {
        console.log("Failed to delete");
        dispatch(setShowMessage(translations[currentLanguage].deletefailed || "Failed to delete"));
      }
      fetchBankList();
    } catch (error) {
      console.error("An error occurred:", error);

    }
  };

  useEffect(() => {
    if (bankState?.isSuccess) {
      if (bankState.message.result === "success") {
        dispatch(clearaddBank());
      }
    }
  }, [bankState]);

  const clearInpHook = () => {
    setBank({
      bankname: "",
    });
  }

  const editeBank = async (id) => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/get-bank/${id}`;
      const token = localStorage.getItem("rbacToken");
      const config = {
        headers: {
          token: token,
        },
      };

      const response = await Axios.get(url, config);

      if (response.data?.isSuccess) {
        const bankData = response.data.result[0];
        console.log(bankData, "response.data.result");
        setBank(bankData); // Correctly set the bank state with the fetched data
        setShow(2); // Set the show state to 2, to indicate editing mode
      } else {
        console.error("API request was not successful");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
    console.log(banklist, "banklist");
    const rowsData = banklist.map((item, index) => ({
      ...item,
      rowNumber: item.id,
      checkbox: selectAll,
    }));
    setRowData(rowsData);
  }, [banklist, selectAll]);

  const columns = [
    {
      field: "id",
      headerName: (
        <Checkbox
          {...label}
          checked={selectAll}
          onClick={handleHeaderCheckboxClick}
        />
      ),
      minWidth: 90,
      // flex: 1,
      renderCell: (params) => (
        <Checkbox
          {...label}
          checked={params.row.checkbox}
          onClick={() => handleChildCheckboxClick(params.row.id)}
        />
      ),
    },

    {
      field: "bankname",
      headerAlign: "left",
      align: "left",
      headerName: translations[currentLanguage].bankname,
      minWidth: 120,
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.bankname ? params.row.bankname : "-"}`;
      },
    },

    {
      field: "menu",
      headerName: (
        <FontAwesomeIcon icon={faEllipsisV} style={{ marginRight: "15px" }} />
      ),
      className: "bg-dark",
      sortable: false,
      filterable: false,
      headerAlign: "right",
      align: "right",
      disableColumnMenu: true,
      width: 130,
      // flex: 1,
      position: "sticky",
      renderCell: (params) => (
        <div className="d-flex justify-content-center dotHoverempicon ">
          <FontAwesomeIcon icon={faEllipsisV} />
          <div className="expandDiv">
            <Tooltip title={translations[currentLanguage].edit}>
              <button
                className="myActionBtn m-1"
                onClick={() => {
                  editeBank(params.row.id);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </button>
            </Tooltip>
            <Tooltip title={translations[currentLanguage].delete}>
              <button
                onClick={() => {
                  deleteActionCall(params.row);
                }}
                className="myActionBtn m-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="bi bi-trash3"
                  viewBox="0 0 16 16"
                >
                  <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                </svg>
              </button>
            </Tooltip>
          </div>
        </div>
      ),
    },
  ];
  return (
    <>
      <div className="my-3 d-flex align-items-end justify-content-end">
        <div className="d-flex align-items-center" type="button">
          <h6 className="m-0 ps-1">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleShow}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-plus-circle"
                viewBox="0 0 16 16"
              >
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
              </svg>
              &nbsp; {translations[currentLanguage].addbank}
            </button>
          </h6>
          <Button
            variant="btn btn-warning mx-1"
            style={{
              width: "75px",
              height: "40px",
              fontSize: "14px",
              borderRadius: "20px",
            }}
            onClick={() => {
              redirectModal();
            }}
          >
            {translations[currentLanguage].back}
          </Button>
        </div>
      </div>
      <div className="addUser myBorder bg-white rounded p-3">
        <div
          className="mt-4 tableMenuHover"
          style={{ height: "85vh", width: "100%" }}
        >
          <PersistentDataGrid
            rows={rowData}
            columns={columns}
            columnVisibilityModel={holidayColumnShowHideModel}
            onColumnVisibilityModelChange={handleHolidayColumnShowHideChange}
            getRowId={(params) => {
              return params.id;
            }}
            className="rounded"
            style={{
              fontFamily: "Poppins",
              padding: 5,
              backgroundColor: "white",
            }}
            pageSizeOptions={[5, 10, 25]}
            initialState={{
              ...categoryList.initialState,
              pagination: { paginationModel: { pageSize: 10 } },
            }}
            components={{
              Toolbar: GridToolbar,
              NoRowsOverlay: () => (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span>There is no Users with current branch</span>
                </div>
              ),
            }}
            componentsProps={{
              toolbar: {
                position: "right",
                style: { fontFamily: "Poppins", alignSelf: "end" },
              },
            }}
            rowSelection={false}
            autoPageSize={false}
          />
        </div>
        <AlertDeleteModal
          showModal={displayConfirmationModal}
          hideModal={hideConfirmationModal}
          confirmModal={submitDelete}
          type={type}
          id={id}
          message={deleteMessage}
        />
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <h5>
            {show === 1
              ? translations[currentLanguage].addbank
              : translations[currentLanguage].editbank}
          </h5>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <div className="mb-3">
              <label htmlFor="recipient-name" className="col-form-label">
                {translations[currentLanguage].bankname}:
              </label>
              <input
                type="text"
                name="bankname"
                className="form-control"
                onChange={changeHandler}
                defaultValue={bank.bankname}
              />
            </div>

          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {translations[currentLanguage].close}
          </Button>
          <Button variant="primary" onClick={savedata}>
            {translations[currentLanguage].save}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddBank;
